module.exports = __webpack_public_path__ + "static/media/location-img-1.dcf9d663.jpg";